export const positionInitialState = [
  {
    id: "1",
    title: "President",
    position_load: "12",
  },
];
